/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import BirthContainer from './container/BirthContainer';
import SearchContainer from './container/search/SearchContainer';
import BirthCertificateListingContainer from './container/records/container/BirthCertificateListingContainer';
import BirthCertificateCsvImportContainer from './container/import-csv/containers/BirthCertificateCsvImportContainer';
import BirthCertificateFileImportContainer from './container/import-file/containers/BirthCertificateFileImportContainer';
import BirthCertificateSettingsContainer from './container/birth-settings/containers/BirthCertificateSettingsContainer';
import QrVerifierModal from './components/QrVerifierModal';

function TabContainer({ match, pathName, permissions }) {
  const setModal = useContext(ModalContext);

  const handleOpenQrVerifierModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <QrVerifierModal />,
      title: 'Scan QR Code',
      modalSize: 'modal-md',
    });
  };

  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              <li className="nav-item">
                <Link
                  to="/civil-registry/birth-certificate"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf(
                      '/civil-registry/birth-certificate/transactions'
                    ) > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Birth Certificate
                </Link>
              </li>
              {Acl(permissions, ['SEARCH BIRTH CERTIFICATE']) && (
                <li className="nav-item">
                  <Link
                    to="/civil-registry/birth-certificate/search"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf(
                        '/civil-registry/birth-certificate/search'
                      ) > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Search
                  </Link>
                </li>
              )}
              <li className="nav-item">
                <Link
                  to="/civil-registry/birth-certificate/records-maintenance"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf(
                      '/civil-registry/birth-certificate/records-maintenance'
                    ) > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Record Maintenance
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/civil-registry/birth-certificate/file-import"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf(
                      '/civil-registry/birth-certificate/file-import'
                    ) > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  File Import
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  to="/civil-registry/birth-certificate/csv-import"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf(
                      '/civil-registry/birth-certificate/csv-import'
                    ) > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  CSV Import
                </Link>
              </li>
              <li className="nav-item">
                <button
                  type="button"
                  onClick={handleOpenQrVerifierModal}
                  className="nav-link btn-settings-tab border-right py-3 px-5 "
                >
                  QR Verifier
                </button>
              </li>
              {/* <li className="nav-item">
                <Link
                  to="/civil-registry/birth-certificate/settings"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf(
                      '/civil-registry/birth-certificate/settings'
                    ) > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Settings
                </Link>
              </li> */}
            </ul>
          </div>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => <Redirect to={`${match.path}/transactions`} />}
          />
          <Route
            path={`${match.path}/transactions`}
            component={BirthContainer}
          />
          <Route path={`${match.path}/search`} component={SearchContainer} />
          <Route
            path={`${match.path}/records-maintenance`}
            component={BirthCertificateListingContainer}
          />
          <Route
            path={`${match.path}/file-import`}
            component={BirthCertificateFileImportContainer}
          />
          <Route
            path={`${match.path}/csv-import`}
            component={BirthCertificateCsvImportContainer}
          />
          {/* <Route
            path={`${match.path}/settings`}
            component={BirthCertificateSettingsContainer}
          /> */}
        </Switch>
      </div>
    </React.Fragment>
  );
}

TabContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(TabContainer);
